<template>
    <div>
        <el-form :model="attributeForm" ref="ruleForm" label-width="70px" class="demo-ruleForm">
            <el-form-item
                v-for="(item, index) of attributeForm.attributeList"
                :key="index"
                :rules="
                    item.isRequired == true
                        ? {
                              required: true,
                              message: item.nameKv.kvName + '不能为空',
                              trigger: 'blur'
                          }
                        : { required: false }
                "
                :prop="item.valueType == 1 ? 'attributeList.' + index + '.spuValue.value' : 'attributeList.' + index + '.spuValue.value'"
                :label="item.nameKv.kvName"
            >
                <el-input size="small" v-model="item.spuValue.value" :disabled="stateDisabled" v-if="item.valueType == 2"></el-input>

                <el-select v-if="item.valueType == 'SELECT' || item.valueType == 'MULTI_SELECT'" v-model="item.spuValue.value" :disabled="stateDisabled" size="small">
                    <el-option
                        v-for="(valueKv, index) of item.valueKvList"
                        :key="index"
                        :label="valueKv.kvName"
                        :value="valueKv.kvName"
                    ></el-option>
                </el-select>

                <GridSelect
                    v-if="item.valueType == 'GridSelect'"
                    style="width: 200px"
                    title="选择型号"
                    labelName="keyPropertyText"
                    labelValue="spuId"
                    :value="item.spuValue.value"
                    :limit="1"
                    :stateDisabled="stateDisabled"
                    size="small"
                    placeholder="请选择型号"
                    @getValue="getValue"
                    :columns="[
                        {
                            prop: 'fullName',
                            label: '品牌名称',
                            img: 'img'
                        }
                    ]"
                    :searchs="[
                        {
                            prop: 'brandName',
                            label: '品牌名称'
                        }
                    ]"
                    :dataListUrl="`/huicaiyun/huicaiyunproduct/getSpuList?categoryId=${categoryId}&brandName=${brandName}`"
                    entityBeanName="brandName"
                    :queryEntityUrl="`/huicaiyun/huicaiyunproduct/getSpuList?categoryId=${categoryId}&brandName=${brandName}`"
                >
                </GridSelect>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import eventBus from '../../api/eventBus';
import GridSelect from '../huicaiyun/brandModel.vue';

export default {

    props: {
        pubVue: {
            type: Object
        }
    },
    components: {
        GridSelect
    },
    data() {
        return {
            attributeForm: {
                nameKv: '',
                attributeList: []
            },
            brandName: null,
            categoryId: null,
            brandId: null,
            rules: {},
            stateDisabled: false,

        };
    },
    mounted() {

    },
    created() {
        eventBus.$on('pushSpuList', (data,categoryId) => {
            this.categoryId = categoryId
            this.attributeForm.attributeList = data.base
            this.attributeForm.attributeList.forEach((item)=>{
                if(item.nameKv.kvName == '型号'){
                    item.valueType = 'GridSelect'
                    return
                }
            })
            this.$forceUpdate()
        })

        // 修改品牌，把前面页面的品牌名称带过来
        eventBus.$on('brandName', data => {
            this.brandName = data
            for (let i = 0; i < this.attributeForm.attributeList.length; i++) {
                if(this.attributeForm.attributeList[i].nameKv.kvName == "品牌"){
                    this.attributeForm.attributeList[i].spuValue.value = data
                    return
                }
            }
        })
        eventBus.$on('spuList', (data, state) => {
            this.attributeForm.attributeList = JSON.parse(JSON.stringify(data));
            if (state == 'check') {
                this.stateDisabled = true;
            } else {
                this.stateDisabled = false;
            }
            // this.$forceUpdate();

        });
    },
    beforeDestroy() {
        eventBus.$off('spuList');
    },
    methods: {
        validateForm() {
            let flag = true;
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    flag = true;
                } else {
                    flag = false;
                }
            });
            return flag;
        },

        addSpecifications(item) {
            item.disabled = 0;
            this.$forceUpdate();
            for (let element of item.valueKvList) {
                element.name = item.nameKv.kvName;
            }

            let obj = {
                kvName: item.nameKv.kvName,
                valueKv: item.valueKvList
            };
            eventBus.$emit('Specification', obj);
        },
        getValue(id,name){

            for (let i = 0; i < this.attributeForm.attributeList.length; i++) {
                if(this.attributeForm.attributeList[i].nameKv.kvName == "型号"){
                    this.attributeForm.attributeList[i].spuValue.value = name
                }
            }
        },
    }
};
</script>
<style lang="scss" scoped>
::v-deep .el-input {
    width: 200px;
}
::v-deep .el-select {
    width: 200px;
}
</style>
